import { CATEGORIES } from './constants';

const alphabetize = (categories) =>
  categories.sort((a, b) => {
    const categoryA = a.name.toUpperCase();
    const categoryB = b.name.toUpperCase();
    if (categoryA < categoryB) {
      return -1;
    }
    if (categoryA > categoryB) {
      return 1;
    }
    return 0;
  });

const buildCategories = (items, category) => {
  const data =
    items &&
    items.map((item) => ({
      ...item,
      children: [],
      queryStringId: `${category}=${encodeURIComponent(item.queryAs)}`,
    }));

  const transformedData = data.reduce((array, item) => {
    if (!item.parent) {
      array.push(item);
    } else {
      const [parent] = data.filter((object) => object.hierarchyId === item.parent);
      // eslint-disable-next-line no-unused-expressions
      parent && parent.children.push(item);
      parent.children = alphabetize(parent.children);
    }

    return array;
  }, []);

  return alphabetize(transformedData);
};

export const loadCategory = async (qs) => {
  const [match, csrf] = document.cookie.match(/csrf=([^;]*)/) || []; // eslint-disable-line no-unused-vars

  const response = await fetch(`/api/jobs/taxonomy?category=${qs}`, {
    headers: {
      'x-csrf-token': csrf,
      'Content-Type': 'application/json',
    },
  });
  const data = await response.json();

  return buildCategories(data[qs], qs);
};

export const mzTrack = (type, eventTitle, payload, moduleType = 'save-search-button') => {
  if (window._mz && window._mze) {
    const obj = {
      eventTitle,
      module: {
        type: moduleType,
      },
    };
    window._mz.emit(window._mze[type], payload ? { ...obj, payload } : obj);
  }
};

export const transformCategories = () => {
  return CATEGORIES.map((category) => {
    return { ...category, active: false };
  });
};

export const distanceUnit = (locale) => (locale === 'gb' || locale === 'us' ? 'miles' : 'km');
